import * as _ from 'lodash';
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from 'react-redux';
import { IAppointment, IKIOSKModel, IkioskMenuIds, IKioskOtherServiceMenu } from "../../../../models/kioskModel2";
import { menuTypeAction, selectedAppointAction } from "../../../../store/actions";
import { Ilanguages } from '../../../../models/utilitiesModel';

const AuthSuccesMenus: React.FC = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation("translations");
    const language: string = useSelector((state: any) => (state?.kioskReducer2 as IKIOSKModel)?.language || Ilanguages.ENG);
    const menusData: IKioskOtherServiceMenu[] = useSelector((state: any) => (state?.kioskReducer2 as IKIOSKModel)?.welcomeMenus || []);
    const appoinementsData: IAppointment[] = useSelector((state: any) => (state?.kioskReducer2 as IKIOSKModel)?.appointmentsData || []);
    const activeAppoinements: any = Object.keys(_.groupBy(appoinementsData, ("branchType")));
    activeAppoinements.push(IkioskMenuIds.OTHERSERVICES, IkioskMenuIds.APPOINMENTS);
    console.log("activeAppoinements", activeAppoinements);
    const getClassname = (menuCode) => {
        let classname = '';
        let icon = 'flow_card cyan';
        switch (menuCode) {
            case IkioskMenuIds.APPOINMENTS:
                classname = "flow_card cyan pointer";
                icon = "icon_m42kiosk_appointments";
                break;
            case IkioskMenuIds.LAB:
                classname = "flow_card slate_blue pointer";
                icon = "icon_m42kiosk_laboratory";
                break;
            case IkioskMenuIds.RADIOLOGY:
                classname = "flow_card blue_cyan pointer";
                icon = "icon_m42kiosk_radiology";
                break;
            case IkioskMenuIds.PHARMACY:
                classname = "flow_card cyan pointer";
                icon = "icon_m42kiosk_pharmacy";
                break;
            case IkioskMenuIds.OTHERSERVICES:
                classname = "flow_card slate_blue pointer";
                icon = "icon_m42kiosk_other_services";
                break;
            default:
                break;
        }
        return { classname, icon };
    };
    const handlemenuclick = (menuCode: string) => {
        if (menuCode === IkioskMenuIds.LAB || menuCode === IkioskMenuIds.PHARMACY || menuCode === IkioskMenuIds.RADIOLOGY || menuCode === IkioskMenuIds.APPOINMENTS) {
            dispatch(selectedAppointAction(menuCode));
        }
        else {
            dispatch(menuTypeAction(IkioskMenuIds.OTHERSERVICES));
        }
    };
    return (
        <div className='Kiosk_welcome'>
            <h2>{t("kiosktranslation.Welcome" + language)}</h2>
            <span>{t("kiosktranslation.selectOptions" + language)}<br />{t("kiosktranslation.help" + language)}</span>
            <div className='d-flex flex-wrap gap-5 mt-4'>
                {menusData?.map((x, i) => (
                    //adding the condition based on disable condition
                    <div key={i} className={activeAppoinements.includes(x?.branchTypeCode) ? getClassname(x?.branchTypeCode)?.classname : getClassname(x?.branchTypeCode)?.classname + " disabled"} onClick={() => { activeAppoinements.includes(x?.branchTypeCode) && handlemenuclick(x.branchTypeCode) }}>
                        <i className={getClassname(x?.branchTypeCode)?.icon}></i>
                        <span>{language === Ilanguages.ENG ? x.branchNameEn : x.branchNameAr}</span>
                    </div>
                ))}
            </div>
        </div>
    )
}
export default React.memo(AuthSuccesMenus);